<!--
 * @Author: ningbo.kang
 * @Date: 2020-06-02 17:43:31
 * @LastEditors: wenpan.cao@ecarxgroup.com
 * @LastEditTime: 2023-08-01 15:01:51
 * @Description: 描述
 -->
<template>
  <div widget-type="link">
    <ul class="ant-checkbox-group instance-content">
      <li class="instance-item" v-for="(item, index) in showData" :key="index" @click="checkProcess(item)">
        <!-- 流程信息 -->
        <div class="instance-info">
          <div class="title">{{item.subject}}</div>
          <span class="desc">{{item.creator}} {{$t('wg.createAt')}} {{item.createTime}}</span>
        </div>
        <a-tag :color="STATUE_STYLE_MAP[item.status]">{{$t(`wg.status.${item.status}`)}}</a-tag>
        <a-icon type="delete" v-if="!disabled" class="delete-icon" @click.stop="deleteItem(item.id)"/>
      </li>
      <a href="javascript:;" v-if="!disabled" @click="addInstanceLink"><a-icon type="plus" />{{$t('wg.bt.addLinks')}}</a>
    </ul>
    <!-- 侧边抽屉 流程可选择区 -->
    <a-drawer
      :title="$t('wg.selectFlow')"
      placement="right"
      :closable="false"
      :visible="visible"
      :after-visible-change="afterVisibleChange"
      @close="onClose"
      width="70%"
      :loading="true"
      destroyOnClose
    >
      <div class="flex-content">
        <!-- 搜索区 关键字搜索 -->
      <a-input-search :placeholder="$t('wg.searchproname')" enter-button @search="onSearch" />
      <!-- tab栏 默认 待办、已办、抄送我、已发起 当onlyPassed为true时 不展示待办栏-->
      <a-tabs :default-active-key="defaultActiveKey" @change="callbackTab">
        <template v-for="item in tabList">
          <a-tab-pane :key="item.key" :tab="item.label" v-if="!onlyPassed || item.key !== '1'">
            <!-- 增加筛选框 -->
            <a-dropdown :trigger="['click']">
              <span class="ant-dropdown-link" @click="e => e.preventDefault()">
                {{processLab}} <a-icon type="down" />
              </span>
              <a-menu slot="overlay" class="bpm-menu-dropdown">
                <a-menu-item v-for="process in processList" :key="process.defKey" @click="changeLab(process, '1')">
                  <a href="javascript:;">{{process.defName}}</a>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
            <a-dropdown :trigger="['click']" style="margin-left: 12px" v-if="activeTab !== '1' && !onlyPassed">
              <span class="ant-dropdown-link" @click="e => e.preventDefault()">
                {{statusLab}} <a-icon type="down" />
              </span>
              <a-menu slot="overlay" class="bpm-menu-dropdown">
                <a-menu-item v-for="status in statusList" :key="status.value" @click="changeLab(status, '2')">
                  <a href="javascript:;">{{status.label}}</a>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
            <!-- 数据展示 -->
            <a-spin :spinning="spinning">
              <ProcessItem @onChange="changeSelect" @changePage="changePage" :dataList="dataList" :selected="selectedData" :tab="activeTab" :total="total"></ProcessItem>
            </a-spin>
          </a-tab-pane>
        </template>
      </a-tabs>
      <div
        :style="{
          position: 'absolute',
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e8e8e8',
          padding: '10px 16px',
          left: 0,
          background: '#fff',
          borderRadius: '0 0 4px 4px',
        }"
      >
        <a-button type="primary" @click="onClose(true)">
          {{$t('wg.bt.confirm')}}
        </a-button>
        <a-button style="marginLeft: 8px" @click="onClose(false)">
          {{$t('wg.bt.cancel')}}
        </a-button>

      </div>
      </div>

    </a-drawer>
  </div>
</template>
<script>
import baseMixin from '../../lib/baseMixin';
import ProcessItem from './processItem.vue';

export default {
  mixins: [baseMixin],
  components: { ProcessItem },
  data() {
    return {
      visible: false,
      options: {
        inline: true,
        defaultValue: '',
        showLabel: false,
        options: [],
        required: false,
        width: '100%',
        remote: false,
        remoteType: 'func',
        remoteOption: '',
        remoteOptions: [],
        props: {
          value: 'value',
          label: 'label',
        },
        remoteFunc: '',
        customClass: '',
        labelWidth: 100,
        isLabelWidth: false,
        hidden: false,
        dataBind: true,
        disabled: false,
      },
      dataList: [],
      selectedData: [],
      defaultActiveKey: '4',
      tabList: [
        {
          key: '1',
          label: '待办',
        },
        {
          key: '2',
          label: '已办',
        },
        {
          key: '3',
          label: '抄送我',
        },
        {
          key: '4',
          label: '已发起',
        },
      ],
      activeTab: '4',
      processList: [],
      statusList: [
        {
          value: '0',
          label: '全部状态',
        },
        {
          value: 'running',
          label: '审批中',
        },
        {
          value: 'back',
          label: '已驳回',
        },
        {
          value: 'end',
          label: '已归档',
        },
        {
          value: 'revoke',
          label: '已撤销',
        },
        {
          value: 'manualend',
          label: '已作废',
        },
      ],
      processLab: '全部审批',
      statusLab: '全部状态',
      spinning: true,
      API_TYPE_MAP: {
        1: '0',
        2: '40',
        3: '10',
        4: '30',
      },
      api: 'getMyWorkFlowVoList',
      searchData: '',
      sort: {
        field: 'reqDate',
        order: 'desc',
      },
      defKeyList: null,
      showData: [],
      STATUE_STYLE_MAP: {
        running: 'blue',
        back: 'red',
        end: 'green',
        manualend: 'orange',
        revoke: 'purple',
      },
      activeLabStatus: '',
      activeLabProcess: '',
      onlyPassed: false,
      cacheData: [],
      requestType: '30',
      pageNum: 1,
      busyFlag: false,
      total: 0,
    };
  },
  mounted() {
    const { onlyPassed, rangeList = [], rangeSelect } = this.widget.options;
    this.onlyPassed = onlyPassed;
    // if (onlyPassed) {
    //   this.defaultActiveKey = '4';
    //   this.activeTab = '4';
    // }
    /**
     * @description 整理数据 this.widget.options中 rangeSelect,rangeList, onlyPassed
     * @param rangeSelect true 获取rangeList中defKey集合进行请求数据
     * @param rangeList 可选流程集合
     * @param onlyPassed 是否仅可选择审批通过的单据
     */
    this.defKeyList = rangeSelect ? rangeList.map(item => item.defKey) : [];
  },
  methods: {
    initVal(val) {
      if (!val) return;
      const strVal = val;
      try {
        this.text = strVal?.split(',');
        this.selectedData = this.text;
        if (this.selectedData.length) {
          this.initShowData();
        }
      } catch (error) {
        this.text = [];
      }
    },
    // 初始话数据
    fetchData(defKey) {
      this.spinning = true;
      // 数据请求 接口请求
      const param = {
        pageSize: 10,
        pageNum: this.pageNum,
        requestType: this.requestType,
        subjectName: this.searchData,
        sort: this.sort,
        defKeyList: defKey || this.defKeyList,
        status: this.onlyPassed ? 'end' : this.activeLabStatus,
        groupByInstanceId: true,
      };
      this.remote[this.api](param).then((res) => {
        this.dataList = res?.page?.list || [];
        this.total = res.page.total;
      }).finally(() => {
        this.spinning = false;
      });
    },
    fetchModel() {
      const paramModel = {
        requestType: this.requestType,
        defKeyList: this.defKeyList,
      };
      this.remote.getProcessModelList(paramModel).then((res) => {
        const filterArr = res.list?.map(item => item.flowVOList).flat();
        this.processList = [
          {
            defKey: '0',
            defName: '全部审批',
          },
          ...filterArr,
        ];
      });
    },
    // 加载更多
    changePage(data) {
      this.pageNum = data;
      this.fetchData();
    },
    addInstanceLink() {
      this.selectedData = JSON.parse(JSON.stringify(this.cacheData));
      this.visible = true;
      this.requestType = '30';
      this.activeTab = '4';
      this.defaultActiveKey = '4';
      this.processLab = '全部审批';
      this.statusLab = '全部状态';
      this.api = 'getMyWorkFlowVoList';
      this.pageNum = 1;
      this.dataList = [];
      this.fetchData();
      this.fetchModel();
    },
    afterVisibleChange() {},
    onClose(type) {
      this.visible = false;
      if (type) {
        this.initShowData();
        const newVal = this.selectedData.join(',');
        this.$emit('change', newVal);
      }
    },
    initShowData() {
      if (!this.selectedData.length) return;
      this.remote.getInstancesInfo(this.selectedData).then((res) => {
        this.cacheData = JSON.parse(JSON.stringify(this.selectedData));
        this.showData = res.data || [];
      });
    },
    onSearch(val) {
      this.pageNum = 1;
      this.dataList = [];
      this.searchData = val;
      this.fetchData();
    },
    callbackTab(tab) {
      this.activeTab = tab;
      this.busyFlag = false;
      this.pageNum = 1;
      const todoApi = tab === '1' || tab === '3';
      // 准备参数
      this.requestType = this.API_TYPE_MAP[tab];
      this.api = todoApi ? 'getMyWorkFlowTodoList' : 'getMyWorkFlowVoList';
      this.dataList = [];

      this.processLab = '全部申请';
      this.activeLabProcess = '';
      this.statusLab = '全部状态';
      this.activeLabStatus = '';
      this.fetchData();
      this.fetchModel();
    },
    changeSelect(data) {
      this.selectedData = data;
    },
    changeLab(lab, type) {
      if (type === '1') {
        this.processLab = lab.defName;
        this.activeLabProcess = lab.defKey === '0' ? '' : lab.defKey;
      } else {
        this.statusLab = lab.label;
        this.activeLabStatus = lab.value === '0' ? '' : lab.value;
      }
      const param = [];
      if (this.activeLabProcess) {
        param.push(this.activeLabProcess);
      }
      this.fetchData(param);
    },
    // 删除已选
    deleteItem(id) {
      this.showData = this.showData.filter(item => item.id !== id);
      this.selectedData = this.selectedData.filter(item => item !== id);
      const newVal = this.selectedData.join(',');
      this.$emit('change', newVal);
    },
    // 查看流程
    checkProcess(item) {
      window.open(`${window.location.origin}/#/pages/flow/redirect?instanceId=${item.id}`);
    },
  },
};
</script>
<style lang="less" scoped>
.instance-content{
  width: 100%;
  .instance-item{
    position: relative;
    padding: 8px 16px;
    display: flex;
    align-items: center;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    margin: 6px 0 12px;
    max-width: 480px;
    .status{
      margin-right: 8px;
      font-size: 10px;
      padding: 2px 6px;
      border-radius: 2px;
    }
  }
  .instance-info{
    flex: 1;
    .title{
      font-size: 14px;
      color: #333;
      font-weight: 500;
      cursor: pointer;
    }
    .desc{
      font-size: 10px;
      color: #999;
      cursor: pointer;
    }
  }
  .delete-icon{
    cursor: pointer;
  }
}
.ant-dropdown-link{
  cursor: pointer;
}
.bpm-menu-dropdown{
  max-height: 50vh !important;
  overflow-y: scroll;
  overflow-x: hidden;
}

</style>
